module.exports = __webpack_public_path__ + "static/media/ganesha-ji-flower-1.a6a4711c.gif";